module.exports = __webpack_public_path__ + "static/media/p4_3.9c64170e.png";